import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Coluna from "./coluna";
import { IRelatorio } from "../../interfaces/IRelatorio";
import { IEsteira } from "../../interfaces/IEsteira";
import esteiraNovaService from "../../services/esteiraNovaService";
import empresaNovaService from "../../services/empresaNovaService";
import { IEmpresas } from "../../interfaces/IEmpresas";
import cartaoNovaService from "../../services/cartaoNovaService";
import moment from "moment";
import { joinGroup, startConnection, closeConnection, connectionValid, removeGroup } from '../../services/EsteiraWebSocket';
import { useAuth } from "../../contexts/AuthProvider";
import { uniqueId } from "lodash";
import ModalMapeamento from "./modal-mapeamento";

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';


function NovoAndamentoContas() {

    const { classes } = useLayout()
    const [esteira, setEsteira] = useState(0)
    const [empresa, setEmpresa] = useState(0)
    const [filtro, setFiltro] = useState('')
    const [colunas, setColunas] = useState([{ key: 'Pendentes', value: 'Pendentes' }, { key: 'Em processamento', value: 'Conciliação Automática' }, { key: 'Em Conferencia', value: 'Em Conferência' }, { key: 'Aguardando Identificacao', value: 'Aguardando Identificação' }, { key: 'Concluida', value: 'Concluído' }]);
    const [cartoes, setCartoes] = useState<IRelatorio[]>([])
    const [esteiras, setEsteiras] = useState<IEsteira[]>([])
    const [empresas, setEmpresas] = useState<IEmpresas[]>([])
    const [carregandoEsteiras, setCarregandoEsteiras] = useState(false)
    const [carregandoEmpresas, setCarregandoEmpresas] = useState(false)
    const [carregandoPagina, setCarregandoPagina] = useState(false)
    const [cartoesCarregados, setCartoesCarregados] = useState(false)
    const [show, setShow] = useState(false)
    const { t } = useTranslation();

    const { usuario } = useAuth()

    const buscarCartoes = useMemo(() => async () => {
        if (esteira > 0) {
            const cartoes = await cartaoNovaService.buscarCartoesPorEsteira(esteira, 'extrato')
            setCartoes(cartoes)
            setCartoesCarregados(true)
        }
    }, [esteira])

    const buscarEmpresas = useMemo(() => async () => {
        setCarregandoEmpresas(true);
        const empresas = await empresaNovaService.buscar();
        setEmpresas(empresas);
        setCarregandoEmpresas(false);
    }, [])

    const buscarEsteiras = useMemo(() => async () => {
        setCarregandoEsteiras(true);
        if (empresa > 0) {
            const esteiras = await esteiraNovaService.buscarPorEmpresa(empresa)
            setEsteiras(esteiras)
        }
        setCarregandoEsteiras(false);
    }, [empresa])

    const onUpdateCard = useCallback((acc: any, status: any) => {
        setCartoes((old) => {
            const finded = old.findIndex(f => f.contaEmpresa === acc)

            if (finded >= 0) {
                const cp = [...old];
                cp[finded].status = status
                return cp
            }

            return old
        })
    }, [])

    const preCarregar = useCallback(() => {
        const empresa = localStorage.getItem('bancaria:empresa');
        const esteira = localStorage.getItem('bancaria:esteira');

        if (empresa && esteira) {
            const empresaID = parseInt(empresa)
            const esteiraID = parseInt(esteira)

            if (esteiraID > 0 && empresaID > 0) {
                setEsteira(esteiraID)
                setEmpresa(empresaID)
            }
        }

    }, [])

    const updateLocalStorage = useCallback((empresa, esteira) => {
        localStorage.setItem('bancaria:empresa', empresa.toString())
        localStorage.setItem('bancaria:esteira', esteira.toString())
    }, [])

    const customFilter = useCallback((cards) => {
        return cards.filter((f: any) => {
            const item = `${f.contaEmpresa} - ${f.descricaoEmpresa || f.descricaoReferencial}`.toLowerCase();
            if (item.toLowerCase().includes(filtro)) {
                return f;
            }

            return null;
        });
    }, [filtro])

    useEffect(() => {
        setEsteiras([])
        buscarEsteiras()
        preCarregar()
    }, [buscarEsteiras])

    useEffect(() => {
        buscarEmpresas()
    }, [buscarEmpresas])

    useEffect(() => {
        setCartoes([])
        buscarCartoes()
        setTimeout(() => {
            buscarCartoes()
        }, 60000);
    }, [buscarCartoes])

    useEffect(() => {
        if (usuario && esteira > 0) {
            const connect = async () => {
                await closeConnection();
                await startConnection();
                await joinGroup(`${usuario.clienteID?.toString()}-${esteira}`);
                connectionValid.on("FinalizouProcessamento", (args) => {
                    const data = JSON.parse(args);
                    if (esteira === data.EsteiraID) {
                        onUpdateCard(data.Conta, "Em Conferencia")
                    }
                });
            }

            connect();
        }
    }, [usuario, esteira]);

    return (
        <>
            <PageTitle breadcrumbs={[]}>{t("Mapa de conciliação bancária")}</PageTitle>
            <ModalMapeamento esteiraID={esteira} empresaID={empresa} show={show} toggleModal={() => setShow(false)} />
            <div className='toolbar' id='kt_toolbar'>
                <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                    <DefaultTitle />
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>{t("Lista de Empresas")}</label>
                                <select disabled={carregandoEmpresas || carregandoEsteiras} value={empresa} onChange={(e: any) => {
                                    const emp = parseInt(e.target.value);
                                    setEmpresa(emp);
                                    updateLocalStorage(emp, esteira);
                                }} className="form-control" name="empresas" id="empresas">
                                    <option value={0}>{(carregandoEmpresas || carregandoEsteiras) ? t("Carregando...") : t("Selecione uma empresa")}</option>
                                    {empresas.map((item) => (
                                        <option key={uniqueId()} value={item.id}>{item.razaoSocial || item.nomeFantasia}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>{t("Períodos importados")}</label>
                                <select disabled={carregandoEsteiras || carregandoEmpresas} value={esteira} onChange={(e: any) => {
                                    const est = parseInt(e.target.value);
                                    updateLocalStorage(empresa, est);
                                    setEsteira(parseInt(e.target.value));
                                }} className="form-control" name="periodos" id="periodos">
                                    <option value={0}>{(carregandoEsteiras || carregandoEmpresas) ? t("Carregando...") : t("Selecione um período")}</option>
                                    {esteiras.map((item) => (
                                        <option key={uniqueId()} value={item.id}>{moment(item.periodoInicio).format("DD/MM/YYYY")}-{moment(item.periodoFim).format("DD/MM/YYYY")}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-2 mt-6">
                            <button className="btn btn-success" onClick={() => setShow(true)}>{t("Mapeamento")}</button>
                        </div>
                    </div>
                </div>
                {esteira > 0 && cartoesCarregados && !carregandoEsteiras && (
                    <div className="col-md-12 mt-2">
                        <div className="row">
                            <div className="form-group">
                                <label>{t("Filtros: Código Contábil, Descrição Conta")}</label>
                                <input value={filtro} onChange={(e: any) => setFiltro(e.target.value)} type="text" className="form-control" placeholder={t("Preencha o filtro")} />
                                <label style={{ fontStyle: 'italic' }}>{t("Ao digitar o filtro será aplicado automáticamente")}</label>
                            </div>
                        </div>
                    </div>
                )}

                {(esteiras.find(f => f.id === esteira)?.processamentoBloqueio) && (
                    <div className="col-md-12 mt-2">
                        <div className="row" style={{ display: 'flex' }}>
                            <div className="spinner-border text-success" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            <div className="col-md-2">
                                <label>Aguardando o processo de importação de arquivos iniciais.</label>
                            </div>
                        </div>
                    </div>
                )}


                {esteira > 0 && cartoesCarregados && !carregandoEsteiras && !esteiras.find(f => f.id === esteira)?.processamentoBloqueio && (
                    <div className='col-md-12 mt-2 scrollsize'>
                        <DndProvider backend={HTML5Backend}>
                            <Coluna onUpdateCard={onUpdateCard} data={customFilter(cartoes.filter(f => f.status === 'Pendentes'))} esteira={esteiras.find(f => f.id === esteira)} title={'Pendentes'} value={'Pendentes'} />
                            <Coluna onUpdateCard={onUpdateCard} data={customFilter(cartoes.filter(f => f.status === 'Em processamento'))} esteira={esteiras.find(f => f.id === esteira)} title={'Conciliação Automática'} value={'Em processamento'} />
                            <Coluna onUpdateCard={onUpdateCard} data={customFilter(cartoes.filter(f => f.status === 'Em Conferencia'))} esteira={esteiras.find(f => f.id === esteira)} title={'Em Conferência'} value={'Em Conferencia'} />
                            <Coluna onUpdateCard={onUpdateCard} data={customFilter(cartoes.filter(f => f.status === 'Aguardando Identificacao'))} esteira={esteiras.find(f => f.id === esteira)} title={'Aguardando Identificação'} value={'Aguardando Identificacao'} />
                            <Coluna onUpdateCard={onUpdateCard} data={customFilter(cartoes.filter(f => f.status === 'Concluida'))} esteira={esteiras.find(f => f.id === esteira)} title={'Concluído'} value={'Concluida'} />
                        </DndProvider>
                    </div>
                )}
                {empresa == 0 && (
                    <div className="col-md-12 mt-2">
                        <label>{t('Por favor selecione uma empresa para carregar o mapa.')}</label>
                    </div>
                )}

                {empresa > 0 && esteira == 0 && (
                    <div className="col-md-12 mt-2">
                        <label>{t('Por favor selecione um período para carregar o mapa.')}</label>
                    </div>
                )}

                {((esteira > 0 && empresa > 0 && !cartoesCarregados) || carregandoEsteiras) && (
                    <div className="col-md-12 mt-2">
                        <div className="row" style={{ display: 'flex' }}>
                            <div className="spinner-border text-success" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            <div className="col-md-2">
                                <label>Aguarde enquanto preparamos nosso board.</label>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default NovoAndamentoContas;